export default "__VITE_ASSET__dfc3a17b__"